import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import InvoiceView from "../components/InvoiceView";

export default function OrderInvoicePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { orders } = useStore();
  const order = orders.find((item) => item.id === id) ?? null;

  if (!order) {
    return (
      <div className="yc-fade-up bg-white rounded-card border border-background-200 shadow-card px-8 py-20 text-center">
        <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
          <i className="ri-file-search-line text-3xl"></i>
        </div>
        <h2 className="text-lg font-bold text-foreground-950">
          الطلب غير موجود
        </h2>
        <p className="mt-1 text-sm text-foreground-500">
          تعذّر العثور على الطلب المطلوب.
        </p>
        <button
          type="button"
          onClick={() => navigate("/orders")}
          className="mt-5 inline-flex items-center gap-2 rounded-btn bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-right-line"></i>
          العودة للطلبات
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="yc-screen-only yc-fade-up flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate(`/orders/${order.id}`)}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-white border border-background-200 text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            aria-label="رجوع"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          <div>
            <h2 className="text-xl font-bold text-foreground-950">
              فاتورة طلب <span dir="ltr">#{order.id}</span>
            </h2>
            <p className="mt-1 text-sm text-foreground-500">
              معاينة الفاتورة — يمكنك الطباعة أو الحفظ كـ PDF
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => window.print()}
          className="inline-flex items-center gap-2 rounded-btn bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-printer-line"></i>
          طباعة / حفظ PDF
        </button>
      </div>

      <div className="yc-screen-only yc-fade-up bg-white rounded-card border border-background-200 shadow-card overflow-hidden">
        <InvoiceView order={order} />
      </div>

      <div className="yc-print-only">
        <InvoiceView order={order} />
      </div>
    </div>
  );
}